import styled from "styled-components";
import { Typography } from "antd";
import { CompanyLogo } from "@bindeleddet/core/components";

const { Title } = Typography;

export const StyledTitle = styled(Title)`
  top: 40%;
  text-align: center;
  margin-bottom: 0;
`;

export const StyledHr = styled.hr`
  border: 0;
  background-color: #d8d8d8;
  height: 0.03em;
  width: 100%;
  line-height: 0;
  margin-top: 0;
  margin-bottom: 2%;
`;

export const StyledCompanyLogo = styled(CompanyLogo)`
  background-position: top;
  :before {
    background-position: top;
  }
`;
